<template>
  <v-layout>
    <v-spacer />
    <PoClientsList
      :clients="clients"
    />
    <v-btn
      v-if="$isAllowed('view', 'DownloadAction')"
      icon
      @click="clickPrint"
      :disabled="downloadActionDisabled"
      :loading="downloadActionLoading"
      :title="$t('poLineItemStatus.printBtnTitle')"
      small
      class="mx-1"
    >
      <v-icon>print</v-icon>
    </v-btn>
    <v-btn
      v-if="$isAllowed('view', 'Instructions')"
      icon
      @click="clickHelp"
      :title="$t('poLineItemStatus.helpBtnTitle')"
      small
      class="mx-1"
    >
      <v-icon>help_outline</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import PoClientsList from '@/components/PoDetails/PoClientsList.vue';

export default {
  name: 'PoLineItemStatus',
  components: {
    PoClientsList,
  },
  menu: false,
  methods: {
    clickPrint() {
      this.$emit('po-line-items-download-approval');
    },
    clickHelp() {
      this.$emit('toggle-instructions');
    },
  },
  props: {
    clients: {
      type: Array,
      required: true,
    },
    downloadActionLoading: {
      type: Boolean,
      required: true,
    },
    downloadActionDisabled: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<i18n>
{
  "en": {
    "poLineItemStatus": {
      "helpBtnTitle": "Instructions",
      "printBtnTitle": "Print Approval Document"
    }
  }
}
</i18n>
